// @flow
import React from 'react';
import ReactSelect from 'react-select';
import { customStyles, customTheme, SelectLayout } from './selectStyles';
import NotificationMessage from '../NotificationMessage';

type SelectProps = {
  error?: ?{
    message?: ?string,
  },
  iconDecoration?: ?string,
  isClearable?: boolean,
  isDisabled?: boolean,
  isLoading?: boolean,
  isMulti?: boolean,
  isSearchable?: boolean,
  loadingMessage?: () => string,
  noOptionsMessage?: () => string,
  placeholder: ?string,
  size: string,
};

const Select = ({ size, iconDecoration, error, ...props }: SelectProps) => (
  <SelectLayout>
    <ReactSelect
      {...props}
      styles={customStyles(iconDecoration, size, error)}
      theme={customTheme(size)}
    />
    {error?.message && (
      <NotificationMessage styleType="error">{error?.message}</NotificationMessage>
    )}
  </SelectLayout>
);

export default Select;

Select.defaultProps = {
  error: undefined,
  iconDecoration: undefined,
  isClearable: false,
  isDisabled: false,
  isLoading: false,
  isMulti: false,
  isSearchable: true,
  loadingMessage: () => 'Loading...',
  noOptionsMessage: () => 'No options found',
  placeholder: 'Select...',
  size: 'medium',
};
